export enum EViewSolarEstimationSolarProductCategory {
  INVERTERS = "INVERTERS",
  BATTERIES = "BATTERIES",
  PANELS = "PANELS",
  WATER_HEATERS = "WATER_HEATERS",
  WATER_HEATER_CONTROLLERS = "WATER_HEATER_CONTROLLERS",
  CHARGE_CONTROLLERS = "CHARGE_CONTROLLERS",
}
